import { shipHull, type GameState } from '@sd/sim';

/** How long a fleet stays marked after a hit, in ticks: 5 s of game time. */
const HIT_TICKS = 50;

/**
 * Which of the player's fleets took damage lately (#156, the author's note: a red «!»
 * on the unit and on the map where it is hit). Watched ship by ship, so a fleet split
 * or merged is not mistaken for one that lost hull.
 */
export class HitWatch {
  private hull = new Map<number, number>();
  private until = new Map<number, number>();
  private lastTick = -1;

  update(state: GameState, me: string): ReadonlySet<number> {
    // A match replayed from the start, or a fresh one: nothing from before counts.
    if (state.tick < this.lastTick) {
      this.hull.clear();
      this.until.clear();
    }
    this.lastTick = state.tick;
    const hull = new Map<number, number>();
    const hit = new Set<number>();
    for (const f of state.fleets) {
      if (f.owner !== me) continue;
      for (const s of f.ships) {
        const now = shipHull(s);
        const was = this.hull.get(s.id);
        hull.set(s.id, now);
        if (was !== undefined && now < was - 1e-6) this.until.set(s.id, state.tick + HIT_TICKS);
        if ((this.until.get(s.id) ?? -1) > state.tick) hit.add(f.id);
      }
    }
    for (const [id, until] of this.until)
      if (until <= state.tick || !hull.has(id)) this.until.delete(id);
    this.hull = hull;
    return hit;
  }
}
